import type { AxiosError } from 'axios';

/** An administrator of the company whose email the form just used (D159). */
export interface LinkableAccount {
  userId: string;
  name: string;
}

interface EmailBelongsToUserBody {
  errorCode?: string;
  errorDetails?: { canLink?: boolean; userId?: string; name?: string };
}

/**
 * The 409 of an email that belongs to an administrator of this company who
 * has no employee record: the Add employee form may link the new record to
 * their account instead of asking for another email. Any other owner
 * answers with a message and no link, and is not matched here.
 */
export function linkableAccountFrom(error: unknown): LinkableAccount | null {
  const data = (error as AxiosError<EmailBelongsToUserBody> | undefined)
    ?.response?.data;
  if (data?.errorCode !== 'EMAIL_BELONGS_TO_USER') return null;
  const details = data.errorDetails;
  if (!details?.canLink || !details.userId) return null;
  return { userId: details.userId, name: details.name ?? '' };
}
